import * as tslib_1 from "tslib";
import { EventDispatcher } from "../events/EventDispatcher";
var FileReference = (function (_super) {
    tslib_1.__extends(FileReference, _super);
    function FileReference() {
        return _super.call(this) || this;
    }
    //Displays a file-browsing dialog box that lets the user select a file to upload.
    FileReference.prototype.browse = function (typelist) {
        console.log("browse not implemented yet in flash/FileReference");
        return false;
    };
    //Starts the upload of the file to a remote server.
    FileReference.prototype.upload = function (url) {
        console.log("upload not implemented yet in flash/FileReference");
        return false;
    };
    //Starts the load of a local file selected by a user.
    FileReference.prototype.load = function () {
        console.log("load not implemented yet in flash/FileReference");
    };
    //Opens a dialog box that lets the user save a file to the local filesystem.
    FileReference.prototype.save = function (data, defaultFileName) {
        if (defaultFileName === void 0) { defaultFileName = null; }
        console.log("save not implemented yet in flash/FileReference");
    };
    //Requests permission to access filesystem.
    FileReference.prototype.requestPermission = function () {
        console.log("upload not implemented yet in flash/FileReference");
    };
    //Opens a dialog box that lets the user download a file from a remote server.
    FileReference.prototype.download = function (url, defaultFileName) {
        console.log("download not implemented yet in flash/FileReference");
        return false;
    };
    //Cancels any ongoing upload or download operation on this FileReference object.
    FileReference.prototype.cancel = function () {
        console.log("cancel not implemented yet in flash/FileReference");
    };
    return FileReference;
}(EventDispatcher));
export { FileReference };
